var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.39484H19.25M20.25 14.5663H14.75M14.75 14.5663H9.75M14.75 14.5663V19.7091M14.75 14.5663V8.90917M9.75 14.5663H4.25M9.75 14.5663V19.7091M9.75 14.5663V8.90917M17.25 4.02344H7.25C5.59315 4.02344 4.25 5.40495 4.25 7.10914V17.3949C4.25 19.0991 5.59315 20.4806 7.25 20.4806H17.25C18.9069 20.4806 20.25 19.0991 20.25 17.3949L20.25 7.10914C20.25 5.40495 18.9069 4.02344 17.25 4.02344Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTableIcon);
export default __webpack_public_path__ + "static/media/AddTableIcon.575535c50b8e65fe2d11fcbc6fc14dff.svg";
export { ForwardRef as ReactComponent };